import {
  Accordion,
  Badge,
  Button,
  Dropdown,
  Image,
  Nav,
  Navbar,
  OverlayTrigger,
  Tooltip,
  Popover,
  Overlay
} from "@themesberg/react-bootstrap";
import React, { useState } from "react";
import {
  faAddressCard,
  faBook,
  faBoxOpen,
  faBoxes,
  faCalendarAlt,
  faChartPie,
  faCogs,
  faFileAlt,
  faHandHoldingUsd,
  faTimes,
  faTruck,
  faUsers,
  faAddressBook,
  faClipboardList,
  faBookmark,
  faDesktop,
  faBars,
  faUserClock
} from "@fortawesome/free-solid-svg-icons";



import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import ProfilePicture from "../assets/img/team/profile-picture-3.png";
// import ReactHero from "../assets/img/technologies/logo.png";
// import ReactHero from "../assets/img/technologies/petrotec-india.png";
import ReactHero from "../assets/img/team/newBrandpetroteclogo.png";
import { Routes } from "../routes";
import SimpleBar from "simplebar-react";
import ThemesbergLogo from "../assets/img/themesberg.svg";
import { useLocation } from "react-router-dom";
import Footer from "./Footer";
import { faAppStore } from "@fortawesome/free-brands-svg-icons";

export default (props = {}) => {
  const location = useLocation();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const [isContracted, setIsContracted] = useState(false);
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const showClass = show ? "show" : "";
  const moduleName = sessionStorage.getItem("moduleName") || "";
  const modules = moduleName ? moduleName.split(",") : [];
  const withOutSpace = modules.map((item) => item.trimStart());
  const userRole = (role || sessionStorage.getItem("role") || "").toLowerCase().trim();
  const onCollapse = () => setShow(!show);

  const checkAccess = (label) => {
    if (!label) return true;

    // Admin & BackOffice users have full access to all sections
    if (userRole === "admin" || userRole === "back office") return true;

    const lowerLabel = label.toLowerCase().trim();

    // 1. Check direct module list assigned in Access Control
    if (withOutSpace.some((item) => item.toLowerCase().trim() === lowerLabel)) {
      return true;
    }

    // 2. Role-based access rules for Employee and Manager
    if (userRole === "employee") {
      if (lowerLabel === "open" || lowerLabel === "task" || lowerLabel === "activitytracker") {
        return true;
      }
    }

    if (userRole === "manager") {
      if (lowerLabel === "to assign" || lowerLabel === "open" || lowerLabel === "task" || lowerLabel === "activitytracker") {
        return true;
      }
    }

    // 3. Parent collapsable alias support
    if (lowerLabel === "task" || lowerLabel === "activitytracker") {
      if (withOutSpace.some((m) => ["open", "to assign", "task", "activitytracker"].includes(m.toLowerCase().trim()))) {
        return true;
      }
    }

    return false;
  };

  const CollapsableNavItem = (props) => {
    const { eventKey, title, icon, accessLabel, children = null } = props;
    const defaultKey = pathname.indexOf(eventKey) !== -1 ? eventKey : "";
    
    const [showPopover, setShowPopover] = React.useState(false);
    const targetRef = React.useRef(null);
    const hideTimer = React.useRef(null);

    const childrenWithProp = React.Children.map(children, child => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, { isSubMenu: true });
      }
      return child;
    });

    const handleMouseEnter = () => {
      if (hideTimer.current) clearTimeout(hideTimer.current);
      setShowPopover(true);
    };

    const handleMouseLeave = () => {
      hideTimer.current = setTimeout(() => {
        setShowPopover(false);
      }, 300);
    };

    const renderWithTooltip = (element, tooltipTitle) => {
      if (isContracted) {
        return (
          <div ref={targetRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {element}
            <Overlay target={targetRef.current} show={showPopover} placement="right">
              {(overlayProps) => (
                <Popover 
                  {...overlayProps} 
                  id={`popover-${eventKey}`} 
                  onMouseEnter={handleMouseEnter} 
                  onMouseLeave={handleMouseLeave}
                  style={{ ...overlayProps.style, minWidth: '200px', backgroundColor: '#262B40', border: '1px solid #3c4566', zIndex: 1060 }}
                >
                  <div className="popover-header" style={{ backgroundColor: '#262B40', color: 'white', borderBottom: '1px solid #3c4566', padding: '0.5rem 1rem', fontSize: '1rem', fontWeight: 'bold' }}>
                    {tooltipTitle}
                  </div>
                  <div className="popover-body p-0" onClick={() => setShowPopover(false)}>
                    <Nav className="flex-column popover-sidebar-menu">
                      {childrenWithProp}
                    </Nav>
                  </div>
                </Popover>
              )}
            </Overlay>
          </div>
        );
      }
      return element;
    };

    return (
      checkAccess(accessLabel) && (
        <Accordion as={Nav.Item} defaultActiveKey={defaultKey}>
          <Accordion.Item eventKey={eventKey}>
            {renderWithTooltip(
              <Accordion.Button
                as={Nav.Link}
                className="d-flex justify-content-between align-items-center"
              >
                <span>
                  <span className="sidebar-icon">
                    <FontAwesomeIcon icon={icon} />{" "}
                  </span>
                  <span className="sidebar-text">{title}</span>
                </span>
              </Accordion.Button>,
              title
            )}
            <Accordion.Body className="multi-level">
              <Nav className="flex-column">{childrenWithProp}</Nav>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )
    );
  };

  // const NavItem = (props) => {
  //   //props
  //   const {
  //     title,
  //     link,
  //     subLink,
  //     external,
  //     target,
  //     icon,
  //     accessLabel,
  //     image,
  //     badgeText,
  //     badgeBg = "secondary",
  //     badgeColor = "primary",
  //   } = props;
  //   const classNames = badgeText
  //     ? "d-flex justify-content-start align-items-center justify-content-between"
  //     : "";
  //   const navItemClassName =
  //     link === pathname || subLink === pathname ? "active" : "";
  //   const linkProps = external ? { href: link } : { as: Link, to: link };

  //   return (
  //     withOutSpace.includes(accessLabel) && (
  //       <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
  //         <Nav.Link {...linkProps} target={target} className={classNames}>
  //           <span>
  //             {icon ? (
  //               <span className="sidebar-icon">
  //                 <FontAwesomeIcon icon={icon} />{" "}
  //               </span>
  //             ) : null}
  //             {image ? (
  //               <Image
  //                 src={image}
  //                 width={20}
  //                 height={20}
  //                 className="sidebar-icon svg-icon"
  //               />
  //             ) : null}

  //             <span className="sidebar-text">{title}</span>
  //           </span>
  //           {badgeText ? (
  //             <Badge
  //               pill
  //               bg={badgeBg}
  //               text={badgeColor}
  //               className="badge-md notification-count ms-2"
  //             >
  //               {badgeText}
  //             </Badge>
  //           ) : null}
  //         </Nav.Link>
  //       </Nav.Item>
  //     )
  //   );
  // };
  const NavItem = (props) => {
    const {
      title,
      link,
      subLink,
      external,
      target,
      icon,
      accessLabel,
      image,
      badgeText,
      badgeBg = "secondary",
      badgeColor = "primary",
      isSubMenu = false
    } = props;

    const classNames = badgeText
      ? "d-flex justify-content-start align-items-center justify-content-between"
      : "";
    const navItemClassName =
      link === pathname || (Array.isArray(subLink) && subLink.includes(pathname)) ? "active" : "";

    const validLink =
      typeof link === "string"
        ? link
        : typeof link === "object" && link !== null
        ? link
        : "#";
    const linkProps = external ? { href: validLink } : { as: Link, to: validLink };

    const renderWithTooltip = (element, tooltipTitle) => {
      if (isContracted && !isSubMenu) {
        return (
          <OverlayTrigger
            placement="right"
            trigger={['hover', 'focus']}
            overlay={<Tooltip>{tooltipTitle}</Tooltip>}
          >
            {element}
          </OverlayTrigger>
        );
      }
      return element;
    };

    return (
      checkAccess(accessLabel) && (
        <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
          {renderWithTooltip(
            <Nav.Link {...linkProps} target={target} className={classNames}>
              <span>
                {icon ? (
                  <span className="sidebar-icon">
                    <FontAwesomeIcon icon={icon} />{" "}
                  </span>
                ) : null}
                {image ? (
                  <Image
                    src={image}
                    width={20}
                    height={20}
                    className="sidebar-icon svg-icon"
                  />
                ) : null}

                <span className="sidebar-text">{title}</span>
              </span>
              {badgeText ? (
                <Badge
                  pill
                  bg={badgeBg}
                  text={badgeColor}
                  className="badge-md notification-count ms-2"
                >
                  {badgeText}
                </Badge>
              ) : null}
            </Nav.Link>,
            title
          )}
        </Nav.Item>
      )
    );
  };

  return (
    <>
      {/* <MDBFooter bgColor='light' className='text-center text-lg-start text-muted'></MDBFooter> */}
      <Navbar
        expand={false}
        collapseOnSelect
        variant="dark"
        className="navbar-theme-primary px-4 d-md-none"
      >
        <Navbar.Brand
          className="me-lg-5"
          as={Link}
          to={Routes.DashboardOverview.path}
        >
          <Image src={ReactHero} className="navbar-brand-light" />
        </Navbar.Brand>
        <Navbar.Toggle
          as={Button}
          aria-controls="main-navbar"
          onClick={onCollapse}
        >
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar
          className={`collapse ${showClass} ${isContracted ? 'contracted' : ''} sidebar d-md-block bg-primary text-white`}
        >
          <div className="sidebar-inner px-4 pb-5" style={{ overflowY: 'visible' }}>
            <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pt-3 pb-4">
              <div className="d-flex align-items-center">
                <div className="user-avatar lg-avatar me-4">
                  <Image
                    src={ProfilePicture}
                    className="card-img-top rounded-circle border-white"
                  />
                </div>
                <div className="d-block">
                </div>
              </div>
              <Nav.Link
                className="collapse-close d-md-none"
                onClick={onCollapse}
              >
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <div style={{ position: 'sticky', top: 0, zIndex: 1020, backgroundColor: '#262B40', padding: '1.5rem 0 0.5rem 0', margin: '0 -1.5rem', paddingLeft: '1.5rem', paddingRight: '1.5rem' }}>
              <div className={`d-none d-md-flex mb-2 ${isContracted ? 'justify-content-center' : 'justify-content-end'}`}>
                <div 
                  className="cursor-pointer" 
                  onClick={() => setIsContracted(!isContracted)}
                  style={{ cursor: 'pointer', padding: '0.2rem 0.5rem' }}
                  title="Toggle Sidebar"
                >
                  <FontAwesomeIcon icon={faBars} size="lg" />
                </div>
              </div>

              {!isContracted && (
                <div className="d-flex align-items-center justify-content-center mb-4">
                  <Navbar.Brand className="m-0 p-0" style={{ overflow: 'hidden', transition: 'all 0.3s' }}>
                    <Image src={ReactHero} alt="heroimg" className="navbar-brand-light image-fluid" />
                  </Navbar.Brand>
                </div>
              )}
            </div>
            
            <Nav className="flex-column pt-3 pt-md-0">
              {/* Sidebar link */}
              <NavItem
                title="Dashboard"
                link={Routes.DashboardOverview.path}
                icon={faChartPie}
                accessLabel="Dashboard"
              />


{/* 
              <CollapsableNavItem
                eventKey="mainqoute/"
                title="Quote"
                icon={faAddressCard}
                accessLabel="mainqoute"
              >
                <NavItem
                  title="Configurator"
                  link={Routes.Configutar.path}
                  accessLabel="configurator"
                />

                <NavItem
                  title="PI Component List "
                  link={Routes.salesComponent.path}
                  accessLabel="salesComponent"
                />
               
                <NavItem
                  title="Quote Status"
                  link={Routes.Draftcomp.path}
                  accessLabel="draft"
                />

              </CollapsableNavItem>  */}

                {/* <CollapsableNavItem
                eventKey="funnel/"
                title="Funnel"
                icon={faHandHoldingUsd}
                accessLabel="funnel"
              >
                <NavItem
                  title="Customer"
                  link={Routes.CustomerComp.path}
                  accessLabel="customer"
                />
                <NavItem
                  title="Status "
                  link={Routes.StatusComp.path}
                  accessLabel="status"
                />
           </CollapsableNavItem>   */}


{/* 
              <CollapsableNavItem
                eventKey="activity-tracker/"
                title="Resource Tracker"
                icon={faUserClock}
                accessLabel="task"
              >
                <NavItem
                  title="Employee Dashboard"
                  link={Routes.EmployeeActivityDashboard.path}
                  subLink={[
                    Routes.EmployeeActivityTracker.path,
                    Routes.EmployeeAttendanceHistory.path,
                    Routes.EmployeeActivityLogs.path,
                    Routes.EmployeeBreakHistory.path,
                    Routes.EmployeeTasks.path,
                  ]}
                  accessLabel="open"
                />
                <NavItem
                  title="Manager Analytics"
                  link={Routes.ManagerAnalytics.path}
                  accessLabel="to assign"
                />
              </CollapsableNavItem>   */}

              {/* <NavItem
                  title="Dispenser Record"
                  link={Routes.DispenserRecordTab.path}
                  accessLabel="REDispBoa"
                /> */}

            

               <CollapsableNavItem
                eventKey="Callcenter/"
                title={role === "ro manager" ? "Ro Center" : "Call Center"}
                icon={faDesktop}
                accessLabel="Callcenter"
              >


                <NavItem
                  title="NonTech Ticket"
                  link={Routes.TicketServiceNonTech.path}
                  // icon={faAddressBook}
                  subLink={[
                    Routes.RaiseTicketForm.path,

                  ]}
                  accessLabel="nontech service"
                />





                <NavItem
                  title="Tech Ticket"
                  link={Routes.TicketServiceTech.path}
                  // icon={faClipboardList}

                  accessLabel="tech service"
                />


                <NavItem
                  title="Ro Onboarding"

                  link={Routes.RoList.path}
                  // icon={faBookmark}
                  subLink={[
                    Routes.RoOnboarding.path,

                  ]}
                  accessLabel="Ro onboard"
                />
              </CollapsableNavItem>





              <CollapsableNavItem
                eventKey="master/"
                title="Access Control"
                icon={faUsers}
                accessLabel="Master"
              >
                <NavItem
                  title="User Access Control"
                  link={Routes.AccessControlTabs.path}
                  accessLabel="Access Control"
                />

                {/* commented this because of we using usercreation for create all users */}
                {/* <NavItem
                  title="Customer Creation"
                  link={Routes.CustomerEntryReports.path}
                  subLink={[
                    Routes.CustomerEntry.path,

                  ]}
                  accessLabel="Customer Entry"
                />



                <NavItem
                  title="Dealer Creation"
                  link={Routes.DealerEntryReports.path}
                  subLink={[
                    Routes.DealerEntry.path,

                  ]}
                  accessLabel="Dealer Entry"
                />
 */}


                <NavItem
                  title="User Creation"
                  link={Routes.UserEntryReports.path}
                  subLink={[
                    Routes.UserEntry.path,

                  ]}
                  accessLabel="User Entry"
                />

              </CollapsableNavItem>


              <NavItem
                title="Production Master"
                icon={faHandHoldingUsd}
                link={Routes.ProductionList.path}
                subLink={[
                  Routes.AddProduction.path,

                ]}
                accessLabel="Productionx"
              />




              <NavItem
                title="Dispatch"
                icon={faTruck}
                link={Routes.DispatchList.path}
                subLink={[
                  Routes.AddDispatch.path,

                ]}
                accessLabel="Dispatchx"
              />

              <CollapsableNavItem
                eventKey="Work-Orderx/"
                title="Work Order Field"
                icon={faBoxes}
                accessLabel="Work-Orderx"
              >

                <NavItem
                  title="Installation"

                  link={Routes.InstallationList.path}
                  subLink={[
                    Routes.Installation.path,

                  ]}
                  accessLabel="WOInstall"
                />

                <NavItem
                  title="Calibration"

                  link={Routes.CalibrationList.path}
                  subLink={[
                    Routes.Calibration.path,

                  ]}
                  accessLabel="WOCalibration"
                />

                <NavItem
                  title="Field Job"

                  link={Routes.FieldJobList.path}
                  subLink={[
                    Routes.FieldJob.path,

                  ]}
                  accessLabel="WOField Issue"
                />

              </CollapsableNavItem>

              <CollapsableNavItem
                eventKey="serviceModule/"
                title="Services"
                icon={faCogs}
                accessLabel="Services"
              >


                <NavItem
                  title="Installation"
                  link={Routes.ListOfInstallation.path}
                  subLink={[
                    Routes.GetDispenser.path,
                    Routes.VerificationInstallationList.path
                  ]}
                  accessLabel="SEInstall"
                />



                <NavItem
                  title="Calibration"
                  link={Routes.ListOfCalibration.path}
                  subLink={[
                    Routes.GetCalibrationDispenser.path,
                    Routes.VerificationCalibrationList.path
                  ]}
                  accessLabel="SECalibration"
                />



                <NavItem
                  title="Field Job"
                  link={Routes.ListofFieldIssue.path}
                  subLink={[
                    Routes.GetFieldDispenser.path,
                    Routes.VerificationFieldIssueList.path
                  ]}
                  accessLabel="SECalibration"
                />

              </CollapsableNavItem>
              {/* // for mean time we commented this code because for repots microservice is not ready */}
              {/* 
              <CollapsableNavItem
                eventKey="reports/"
                title="Reports"
                icon={faAddressCard}
                accessLabel="Reports"
              >
                <NavItem
                  title="Master Reports"
                  link={Routes.AllReportsTab.path}
                  accessLabel="REMaster"
                />
                <NavItem
                  title="Dispatch Reports"
                  link={Routes.DispatchWiseTab.path}
                  accessLabel="REDispatch"
                />
                <NavItem
                  title="Work Order Reports"
                  link={Routes.WorkOrderTab.path}
                  accessLabel="REWorkOrder"
                />
                <NavItem
                  title="Services Reports"
                  link={Routes.ServicesTab.path}
                  accessLabel="REServices"
                />
              
              </CollapsableNavItem> */}

              {/* <NavItem
                  title="Dispenser Record"
                  link={Routes.DispenserRecordTab.path}
                  accessLabel="REDispBoa"
                /> */}
            </Nav>
            <footer className="sidebar-footer text-center py-3" style={{ display: isContracted ? 'none' : 'block' }}>
              Version 1.5
            </footer>
          </div>
        </SimpleBar>
      </CSSTransition>

    </>
  );
};
